import { useEffect, useState } from 'react';

const defaultName = 'Desi API';
let brandingRequest;

function loadProviderName() {
  if (!brandingRequest) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    brandingRequest = fetch('https://backend.desiapi.com/api/platform-branding', { cache: 'no-store', signal: controller.signal })
    .then(response => response.ok ? response.json() : null)
    .then(data => typeof data?.providerName === 'string' && data.providerName.trim() ? data.providerName.trim().slice(0, 32) : defaultName)
    .catch(() => defaultName)
    .finally(() => clearTimeout(timeout));
  }
  return brandingRequest;
}

export default function ProviderCredit({ header = false, className = '' }) {
  const [name, setName] = useState(defaultName);
  useEffect(() => {
    let active = true;
    loadProviderName().then(value => { if (active) setName(value); });
    return () => { active = false; };
  }, []);
  return <span className={`provider-credit ${header ? 'provider-credit--header' : 'provider-credit--footer'} ${className}`}>
    <span>{header ? 'by' : 'Powered by'}</span>{' '}<strong>{name}</strong>
  </span>;
}
